module.exports = __webpack_public_path__ + "static/media/my_payments.5994642a.svg";